import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { createPinia } from "pinia";
import PrimeVue from 'primevue/config';
import PrimeVueLocale from './assets/settings/locale.json'
import ToastService from 'primevue/toastservice';
import ApiClientService from './services/api/ApiClientService'
import ErrorHandler from './services/utils/ErrorHandler';
import ToastCreator from './services/utils/Toasts';
import Tooltip from 'primevue/tooltip';
import { getCurrentDomain, setTitleAndFavicon } from './services/utils/Domain';

import 'primevue/resources/themes/aura-light-indigo/theme.css'
import 'primeicons/primeicons.css'

const pinia = createPinia();

const app = createApp(App)
    .use(pinia)
    .use(router)
    .use(PrimeVue, {
        ripple: true,
        locale: PrimeVueLocale
    })
    .use(ToastService)
    .directive('tooltip', Tooltip);

const domain = getCurrentDomain();
setTitleAndFavicon(domain);

app.mount('#app');

export const rootGetters = {
    api: ApiClientService,
    errorHandler: new ErrorHandler(),
    toast: new ToastCreator(),
    inhouse_tenant: process.env.VUE_APP_INHOUSE_TENANT,
    tech_shop_id: process.env.VUE_APP_TECH_SHOP_ID ? parseInt(process.env.VUE_APP_TECH_SHOP_ID) : null
};

